import React from "react";
import { Checkbox } from "@mui/material";
import { checkboxControlSx } from "./memberWorkflowShared";

export type MemberContactAccessGrantProps = {
  contactId: string;
  checked: boolean;
  disabled: boolean;
  /** Persistent status text, such as an unverified account. */
  reason?: string;
  /** Replaces the role-based default label (Create and Update Member use one design label). */
  label?: string;
  /** Design red line under the box (same as the Primary Contact, or details missing after a save). */
  nudge?: string;
  /** Design tooltip shown while the checkbox is disabled. */
  nudgeTitle?: string;
  onChange: (enabled: boolean) => void;
};

export default function MemberContactAccessGrant({
  contactId, checked, disabled, reason, label, nudge, nudgeTitle, onChange,
}: MemberContactAccessGrantProps) {
  // CMP Dashboard (19): only the box toggles; the text beside it is not a
  // label. The box can be ticked before the contact details are entered.
  return <div>
    <div className="flex items-start gap-[10px]" title={disabled && nudgeTitle ? nudgeTitle : undefined}
      style={{ opacity: disabled && nudgeTitle ? 0.5 : undefined }}>
      <span className="flex shrink-0" style={{ cursor: disabled ? "not-allowed" : undefined }}>
        <Checkbox sx={checkboxControlSx} checked={checked} disabled={disabled}
          inputProps={{ "aria-label": `Grant ${contactId} dashboard access` }}
          onChange={event => onChange(event.target.checked)} />
      </span>
      <span className="min-w-0 text-sm leading-[1.55]">{label || (contactId === "accountsPayable"
        ? "Check this box to grant this contact access to the Member Dashboard invoice and payment section only."
        : "Check this box to grant access to the Member Dashboard, excluding the Invoices & Payments section.")}</span>
    </div>
    {nudge && <p role="status" className="mt-1 text-[13px] font-semibold leading-[1.5] text-[#E24C4C]">{nudge}</p>}
    {reason && <p role="status" className="mt-1 text-[13px] text-[#727272]">{reason}</p>}
  </div>;
}
